module.exports = __webpack_public_path__ + "static/playground@large-cd1ff1d0d57751b53608935e5a7546e4.jpg";